import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import CreateSong from "@/pages/CreateSong";
import MyMusic from "@/pages/MyMusic";
import SongDetail from "@/pages/SongDetail";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Payment from "@/pages/Payment";
import Admin from "@/pages/Admin";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import TermsBusinesses from "@/pages/TermsBusinesses";
import CambiosExtra from "@/pages/CambiosExtra";
import Catalogo from "@/pages/Catalogo";
import Promotores from "@/pages/Promotores";
import Concurso from "@/pages/Concurso";
import NegociosRegister from "@/pages/NegociosRegister";
import NegociosLogin from "@/pages/NegociosLogin";
import NegociosPanel from "@/pages/NegociosPanel";
import NegociosInfo from "@/pages/NegociosInfo";
import BusinessPlayer from "@/pages/BusinessPlayer";
import StudioInfo from "@/pages/StudioInfo";
import StudioBuyTime from "@/pages/StudioBuyTime";
import Studio from "@/pages/Studio";
import StemsBuyCredits from "@/pages/StemsBuyCredits";
import "@/App.css";

function RequireAuth({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/create" element={<RequireAuth><CreateSong /></RequireAuth>} />
      <Route path="/payment" element={<RequireAuth><Payment /></RequireAuth>} />
      <Route path="/library" element={<RequireAuth><MyMusic /></RequireAuth>} />
      <Route path="/song/:id" element={<RequireAuth><SongDetail /></RequireAuth>} />
      <Route path="/payment/success" element={<RequireAuth><PaymentSuccess /></RequireAuth>} />
      <Route path="/admin" element={<RequireAuth><Admin /></RequireAuth>} />
      <Route path="/cambios-extra" element={<RequireAuth><CambiosExtra /></RequireAuth>} />
      <Route path="/catalogo" element={<Catalogo />} />
      <Route path="/promotores" element={<Promotores />} />
      <Route path="/concurso" element={<Concurso />} />
      <Route path="/negocios" element={<NegociosRegister />} />
      <Route path="/negocios/login" element={<NegociosLogin />} />
      <Route path="/negocios/panel" element={<NegociosPanel />} />
      <Route path="/negocios/info" element={<NegociosInfo />} />
      <Route path="/play/:commerceId" element={<BusinessPlayer />} />
      <Route path="/studio/info" element={<StudioInfo />} />
      <Route path="/studio/buy" element={<StudioBuyTime />} />
      <Route path="/studio" element={<Studio />} />
      <Route path="/stems/buy" element={<StemsBuyCredits />} />
      <Route path="/quienes-somos" element={<About />} />
      <Route path="/aviso-de-privacidad" element={<Privacy />} />
      <Route path="/terminos" element={<Terms />} />
      <Route path="/negocios/terminos" element={<TermsBusinesses />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-center" theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
